function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0.697675 4.28571H13.2558C13.6413 4.28571 13.9535 3.96607 13.9535 3.57143V0.714286C13.9535 0.319643 13.6413 0 13.2558 0H0.697675C0.312209 0 0 0.319643 0 0.714286V3.57143C0 3.96607 0.312209 4.28571 0.697675 4.28571ZM20.4279 7.85714H13.6744H5.72093C5.33547 7.85714 5.02326 8.17679 5.02326 8.57143V11.4286C5.02326 11.8232 5.33547 12.1429 5.72093 12.1429H20.4279C20.8134 12.1429 21.1256 11.8232 21.1256 11.4286V8.57143C21.1256 8.17679 20.8134 7.85714 20.4279 7.85714ZM23.3023 15.7143H10.7442C10.3587 15.7143 10.0465 16.0339 10.0465 16.4286V19.2857C10.0465 19.6804 10.3587 20 10.7442 20H23.3023C23.6878 20 24 19.6804 24 19.2857V16.4286C24 16.0339 23.6878 15.7143 23.3023 15.7143Z",
  fill: "black"
});

var SvgGanttView = function SvgGanttView(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgGanttView, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gantt_view.eb21a016.svg";
export { ForwardRef as ReactComponent };